import React from 'react';

import { Grid, Link, Text, VStack } from '@/components';
import { useTranslation } from '@/hooks';
import { footerLinks } from '@/statics';

const TermsAndConditions: React.FC<{ plansFile: string }> = ({ plansFile }) => {
  const { t } = useTranslation('components.footer.termsAndConditions');

  return (
    <>
      <VStack alignItems={'start'} gap={0}>
        <Text
          color="text"
          fontWeight="bold"
          fontSize={'lg'}
          display={'flex'}
          alignItems={'start'}
          justifyContent={'start'}
        >
          {t('termsAndConditions')}
        </Text>
        <Grid
          mt={'30px'}
          templateColumns={{ base: 'repeat(1,1fr)', md: 'repeat(2, 1fr)' }}
          columnGap="40px"
          gap="20px"
          justifyContent={'start'}
          alignItems={'start'}
        >
          {footerLinks.StaticsDataTermsAndConditions.map((data, index) => (
            <Link
              key={index}
              href={data.type === 'plans' ? plansFile : data.url}
            >
              <Text
                textAlign={'right'}
                color="text"
                fontWeight="medium"
                fontSize={'sm'}
              >
                {data.title}
              </Text>
            </Link>
          ))}
        </Grid>
      </VStack>
    </>
  );
};

export default TermsAndConditions;
